/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReportLinkShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M10 19a4 4 0 0 1 4-4h2v2h-2a2 2 0 1 0 0 4h2v2h-2a4 4 0 0 1-4-4zm13 0a4 4 0 0 1-4 4h-2v-2h2a2 2 0 1 0 0-4h-2v-2h2a4 4 0 0 1 4 4z" />
        <path d="M19 20h-5v-2h5zM2 2h20v11h-2V4H4v11H2zm14.584 11a5 5 0 1 0-7.252 2.23 6.03 6.03 0 0 1 1.64-1.41A3.001 3.001 0 0 1 11 8.17v4.593l3.941-2.357A2.989 2.989 0 0 1 14.236 13zM13 8.17v1.067l.914-.547A3.028 3.028 0 0 0 13 8.17zM1 16l1.474 1.474c-.573.66-.753 1.236-.753 1.236C.459 22.564 5.019 23 5.019 23c-2.609-1.67-1.942-2.876-.672-3.653L6 21v-5z" />
      </g>
    </g>
  </Icon>
);
export { SvgReportLinkShortcut as ReportLinkShortcut };
